"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Asterisk = function Asterisk(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M18.75 11.9792H6.25001C6.11187 11.9792 5.9794 12.0341 5.88172 12.1318C5.78405 12.2295 5.72917 12.3619 5.72917 12.5001C5.72917 12.6382 5.78405 12.7707 5.88172 12.8684C5.9794 12.966 6.11187 13.0209 6.25001 13.0209H18.75C18.8881 13.0209 19.0206 12.966 19.1183 12.8684C19.216 12.7707 19.2708 12.6382 19.2708 12.5001C19.2708 12.3619 19.216 12.2295 19.1183 12.1318C19.0206 12.0341 18.8881 11.9792 18.75 11.9792Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M16.5511 7.71236L15.0781 9.18551L9.18544 15.0782L7.71229 16.5513C7.61461 16.649 7.55974 16.7815 7.55974 16.9196C7.55974 17.0578 7.61461 17.1902 7.71229 17.2879C7.80996 17.3856 7.94244 17.4405 8.08057 17.4405C8.21871 17.4405 8.35119 17.3856 8.44886 17.2879L9.92201 15.8148L15.8145 9.92209L17.2877 8.44894C17.3854 8.35126 17.4402 8.21879 17.4402 8.08065C17.4402 7.94252 17.3854 7.81004 17.2877 7.71236C17.19 7.61469 17.0575 7.55981 16.9194 7.55981C16.7813 7.55981 16.6488 7.61469 16.5511 7.71236Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M11.9792 6.25008V18.7501C11.9792 18.8882 12.034 19.0207 12.1317 19.1184C12.2294 19.216 12.3619 19.2709 12.5 19.2709C12.6381 19.2709 12.7706 19.216 12.8683 19.1184C12.966 19.0207 13.0208 18.8882 13.0208 18.7501V6.25008C13.0208 6.11195 12.966 5.97947 12.8683 5.8818C12.7706 5.78412 12.6381 5.72925 12.5 5.72925C12.3619 5.72925 12.2294 5.78412 12.1317 5.8818C12.034 5.97947 11.9792 6.11195 11.9792 6.25008Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M7.71229 8.44894L9.18544 9.92209L15.0781 15.8146L16.5513 17.2878C16.6489 17.3854 16.7814 17.4403 16.9196 17.4403C17.0577 17.4403 17.1902 17.3854 17.2878 17.2878C17.3855 17.1901 17.4404 17.0576 17.4404 16.9195C17.4404 16.7813 17.3855 16.6489 17.2878 16.5512L15.8145 15.0782L9.92201 9.18551L8.44886 7.71236C8.35119 7.61469 8.21871 7.55981 8.08058 7.55981C7.94244 7.55981 7.80996 7.61469 7.71229 7.71236C7.61461 7.81004 7.55974 7.94252 7.55974 8.08065C7.55974 8.21879 7.61461 8.35126 7.71229 8.44894Z",
    fill: props.foregroundColor
  }));
};

Asterisk.defaultProps = {
  altText: "Asterisk",
  foregroundColor: "#2D5AB4"
};
Asterisk.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Asterisk;
exports.default = _default;